'use strict';
angular.module('productManageMentRouterModule', []).config(['$stateProvider', function($stateProvider) {
    $stateProvider.state('manageconfig.productmanage.newspaper', {
        url: '/newspaper?site',
        views: {
            'main@manageconfig.productmanage': {
                templateUrl: './manageConfig/productManageMent/newspaper/newspaperManage_tpl.html',
                controller: 'newspaperManageCtrl'
            }
        }
    })
        .state('manageconfig.productmanage.website', {
            url: '/website?site?sitedesc',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/website/main_tpl.html',
                    controller: 'websiteController'
                }
            }
        }).state('manageconfig.productmanage.app', {
            url: '/app?site?sitedesc',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/app/main_tpl.html',
                    controller: 'appController'
                }
            }
        }).state('manageconfig.productmanage.weixin', {
            url: '/weixin?site&type',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/weixin/weixin_tpl.html',
                    controller: 'productManageMentWeiXinCtrl'
                }
            }
        }).state('manageconfig.productmanage.weibo', {
            url: '/weibo??site&type',
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/weibo/weibo_tpl.html',
                    controller: 'productManageMentWeiboCtrl'
                }
            }
        }).state('manageconfig.productmanage.television', {
            url: '/television', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/television/televisionManage_tpl.html',
                    controller: 'televisionManageCtrl'
                }
            }
        }).state('manageconfig.productmanage.broadcast', {
            url: '/broadcast', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/broadcast/broadcastManage_tpl.html',
                    controller: 'broadcastManageCtrl'
                }
            }
        }).state('manageconfig.productmanage.trill', { // 新增抖音渠道
            url: '/trill', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/trill/trill_tpl.html',
                    controller: 'productManageMentTrillCtrl'
                }
            }
        }).state('manageconfig.productmanage.baijiahao', { // 新增抖音渠道
            url: '/baijiahao?site&type', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/baijiahao/baijiahao_tpl.html',
                    controller: 'productManageMentBaijiahaoCtrl'
                }
            } }).state('manageconfig.productmanage.qiehao', { // 新增抖音渠道
            url: '/qiehao?site&type', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/qiehao/qiehao_tpl.html',
                    controller: 'productManageMentQiehaoCtrl'
                }
            }
        }).state('manageconfig.productmanage.toutiaohao', { // 新增头条渠道
            url: '/toutiaohao?site&type', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/toutiaohao/toutiaohao_tpl.html',
                    controller: 'productManageMentToutiaohaoCtrl'
                }
            }
        }).state('manageconfig.productmanage.watermarkmanage', { // 新增水印管理页面
            url: '/watermarkmanage?site&type&name', 
            views: {
                'main@manageconfig.productmanage': {
                    templateUrl: './manageConfig/productManageMent/watermarkAllMgr/watermarkAllMgr_tpl.html',
                    controller: 'productManageMentTheWatermarkMgr'
                }
            }
        });
}]);
